export enum AppRoutes {
	/**
	 * This app's own login. Mounted in every environment — without the
	 * flag mobile has no login of its own and a logged-out user is bounced to the desktop app.
	 */
	login = '/login',
	/** Second-factor challenge. Pre-login sibling of `/login`, same paths as the desktop app. */
	twoFactor = '/twoFactor',
	/** Forced enrollment — the bridge answered 403 `{ enrollmentRequired: true }`. */
	twoFactorEnrollment = '/twoFactorEnrollment',
	personnel = '/personnel/:mode?',
	personnelWithNoMode = '/personnel',
	workersWithNoMode = '/workers',
	workerWithEducation = '/workers/education',
	workers = '/workers/:mode?',
	equipment = '/equipment',
	preferences = '/preferences',
	setup = '/setup',
	projectNotReady = '/projectNotReady',
	activities = '/activities',
	workersOnSite = '/workersOnSite',
	myProfile = '/myProfile',
	logout = '/logout',
	assignTag = '/assignTag',
	notifications = '/notifications',
	notificationsSettings = '/notificationsSettings',
	issues = '/issues',
	monitor = '/monitor',
	monitorFloor = '/monitor/floor',
	monitorArea = '/monitor/area',
	monitorSearch = '/monitor/search',
}
